// funciones para sms.
// eslint-disable-next-line no-unused-vars
import * as FxLog from './FxLog';
import * as FxFetch from './FxFetch';
import * as FxNum from './FxNum';

export const getCredits = async (itSms) => {
  let record = {};
  record['itSms'] = itSms || null; // utiliza la primera cuenta disponible.
  return Promise.all([FxFetch.doJsonX(`sett/sms/get_credits`, record)]).then((result) => {
    let obResponse = {
      credits: FxNum.toString('0.00'),
      message: 'OK'
    };

    if (result[0]) {
      if (result[0].theStatus==='error') {
        obResponse.credits = FxNum.toString('0.00');
        obResponse.message = result[0].theValue.toString(); // rv_no_account_configured, rv_internet_not_reachable
      } else {
        obResponse.credits = FxNum.toString(result[0].theValue.toString());
        obResponse.message = 'OK';
      }
    }

    return obResponse;
  });
}

export const purchaseCredits = async (your_name, your_email, quantity) => {
  let record = {};
  record['your_name'] = your_name;
  record['your_email'] = your_email;
  record['quantity'] = quantity;
  return Promise.all([FxFetch.doJsonX(`sett/sms/purchase`, record)]).then((result) => {
    if (result[0]) {
      if (result[0].theValue.startsWith("rv_")) {
        return 'error';
      } else {
        return 'OK';
      }
    }
  });
}
